import { jwtDecode } from "jwt-decode";
import { User } from "../types/auth";

export const TOKEN_KEY = "auth_token";
export const USER_KEY = "auth_user";
export const REFRESH_TOKEN_KEY = "refresh_token";

// Token management
export const setAuthToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const getAuthToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

export const setRefreshToken = (token: string): void => {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
};

// User management
export const setStoredUser = (user: User): void => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const getStoredUser = (): User | null => {
  const userStr = localStorage.getItem(USER_KEY);
  if (!userStr) return null;
  try {
    return JSON.parse(userStr);
  } catch {
    return null;
  }
};

// Cleanup functions
export const removeTokens = (): void => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

// Alias for removeTokens to maintain backwards compatibility
export const removeAuthData = removeTokens;

// Token utilities
export const decodeToken = (token: string): Partial<User> | null => {
  try {
    return jwtDecode<Partial<User>>(token);
  } catch (error) {
    return null;
  }
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<{ exp: number }>(token);
    if (!decoded.exp) return true;
    // Add a 5-second buffer to prevent edge cases
    return decoded.exp * 1000 < Date.now() - 5000;
  } catch {
    return true;
  }
};
